import React from 'react'
import { observer } from 'mobx-react-lite'
import { MDBCol, MDBRow } from 'mdb-react-ui-kit'
import CeoRace from './../CeoRace/CeoRace.component.jsx'
import LeaderRace from './../LeaderRace/LeaderRace.component.jsx'
import AgentRace from './../AgentRace/AgentRace.component.jsx'
import Store from './../../store'

import './CurrentContestants.component.scss'

const CurrentContestants = () => {
  // Check which columns have contestants (will be visible)
  const ceoHasContestants = Array.isArray(Store?.Racers?.ceo) && Store.Racers.ceo.length > 0
  const leaderHasContestants = Array.isArray(Store?.Racers?.leader) && Store.Racers.leader.length > 0
  const agentHasContestants = Array.isArray(Store?.Racers?.agent) && Store.Racers.agent.length > 0

  // Count how many columns have contestants
  const visibleColumnCount = [ceoHasContestants, leaderHasContestants, agentHasContestants].filter(Boolean).length

  // Determine column width based on visible count
  // 1 column = 100% (12), 2 columns = 50% each (6), 3 columns = 33.33% each (4)
  let columnSize = { size: '12', md: '4' }
  if (visibleColumnCount === 1) {
    columnSize = { size: '12' }
  } else if (visibleColumnCount === 2) {
    columnSize = { size: '12', md: '6' }
  }

  return (
    <section id='CurrentContestantsComponent'>
      <h2 className='current-contestants__heading'>Current Contestants</h2>
      <MDBRow className='mt-4'>
        {ceoHasContestants ? (
          <MDBCol {...columnSize} className='mb-4'>
            <CeoRace />
          </MDBCol>
        ) : (
          <></>
        )}
        {leaderHasContestants ? (
          <MDBCol {...columnSize} className='mb-4'>
            <LeaderRace />
          </MDBCol>
        ) : (
          <></>
        )}
        {agentHasContestants ? (
          <MDBCol {...columnSize} className='mb-4'>
            <AgentRace />
          </MDBCol>
        ) : (
          <></>
        )}
      </MDBRow>
    </section>
  )
}

export default observer(CurrentContestants)
